import type { FunctionComponent } from 'react'

import {
	CurrencyDisplay,
	formatCurrencyForDisplay,
	useIntlConfig,
} from '@monthio/react-components'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { budgetEstimatesCalculatorService } from './budgetEstimatesCalculatorService'
import {
	AmountAndExpandIconContainer,
	BudgetSectionAmount,
	BudgetSectionContainer,
	BudgetSectionHeader,
	BudgetSectionTitle,
	InitialAmountValue,
} from './styledBudgetEstimates'

interface DisposableAmountSectionProps {
	children?: never
	totalDisposableAmount: number
}

export const DisposableAmountSection: FunctionComponent<
	DisposableAmountSectionProps
> = ({ totalDisposableAmount }) => {
	const initialValue = useRef<{ value: number; formatted: string } | undefined>(
		undefined,
	)
	const intlConfig = useIntlConfig()
	const { t } = useTranslation()
	const [disposableAmount, setDisposableAmount] = useState(
		totalDisposableAmount,
	)
	useEffect(() => {
		initialValue.current = {
			formatted: formatCurrencyForDisplay({
				value: String(totalDisposableAmount),
				decimalsLimit: 0,
				intlConfig,
			}),
			value: totalDisposableAmount as any,
		}
		const unsubscribe = budgetEstimatesCalculatorService.subscribe((key) => {
			switch (key) {
				case 'tree.income.total':
				case 'tree.expenses.total':
					const incomeTotal =
						budgetEstimatesCalculatorService.getValue('tree.income.total')
					const expensesTotal = budgetEstimatesCalculatorService.getValue(
						'tree.expenses.total',
					)

					setDisposableAmount(incomeTotal + expensesTotal)
			}
		})

		return unsubscribe
	}, [])

	return (
		<BudgetSectionContainer>
			<BudgetSectionHeader>
				<BudgetSectionTitle>
					{t('minibudgetForm-disposableAmountSection-title')}
				</BudgetSectionTitle>
				<AmountAndExpandIconContainer>
					{initialValue.current?.value != null &&
					initialValue.current?.value !== disposableAmount ? (
						<InitialAmountValue>
							({initialValue.current?.formatted})
						</InitialAmountValue>
					) : null}
					<BudgetSectionAmount>
						<CurrencyDisplay amount={disposableAmount} />
					</BudgetSectionAmount>
				</AmountAndExpandIconContainer>
			</BudgetSectionHeader>
		</BudgetSectionContainer>
	)
}
